<template>
  <div class="wrap">
    <!-- 第一个 大图 -->
    <div :class="picArr && picArr[idx]?'img pointer':'img'" v-for="(index,idx) in 6" :key="index" >
      <div class="wrap_mask">
        <img  
        v-if="picArr && picArr[idx]&&(String(picArr[idx].picUrl).startsWith('http')||String(picArr[idx].picUrl).startsWith('https'))" 
        :src=" picArr && picArr[idx]? picArr[idx].picUrl : ''" alt=""  >
        <img v-else :src="require(`../imgs/${index}.jpeg`)" alt="" >
        <div  class="mask" v-if="picArr && picArr[idx]" @click="buyNow( picArr[idx].iscenicid)" >
          <div class="info">
            <h1 v-if="index==1">{{picArr && picArr[idx]? picArr[idx].szscenicname : ''}}</h1>
            <h2 v-else>{{picArr && picArr[idx]? picArr[idx].szscenicname : ''}}</h2>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataArr: {
      type: Array,
      default: []
    }
  },
  data () {
    return {
      picArr: []
    }
  },
  watch: {
    dataArr: {
      handler: function (val) {
        if (val) {
          this.filterData()
        }
      },
      deep: true
    }
  },
  methods: {
    /**
     * 循环景区数据
     * **/
    filterData () {
      this.dataArr.map((item, index) => {
        item.piclist ? item.piclist.map((subItem, subIndex) => {
          this.picArr.push(
            {
              iscenicid: item.iscenicid,
              szscenicname: item.szscenicname,
              picUrl: subItem.upadder
            }
          )
        }) : null
      })
    },
    /**
      * 立即购票
      * **/
    buyNow (id) {
      let query = this.$route.query;
      if (Object.keys(query).length && query.fxsId) {
        this.$router.push({
          name: 'ticketDetailPage',
          params: { id: id }
        });
      } else {
        if (this.lgtp === '02') {
          this.$router.push({
            name: 'distributor-order'
          });
        } else {
          this.$router.push({
            name: 'ticketDetailPage',
            params: { id: id }
          });
        }
      }
    },
  }
}
</script>

<style lang="less" scoped>
@gap10: 10px;
@bigWidth: 562px;
@bigHeight: 312px;
@smallWidth: 276px;
@smallHeight: 151px;
@white: #fff;
.pointer {
  cursor: pointer;
}
.wrap {
  position: relative;
  .img {
    position: absolute;
    width: @smallWidth;
    height: @smallHeight;
    .wrap_mask {
      position: relative;
      img {
        object-fit: cover;
        width: @smallWidth;
        height: @smallHeight;
      }
      .mask {
        box-sizing: border-box;
        width: 100%;
        height: 98.9%;
        position: absolute;
        left: 0;
        top: 0;
        text-align: center;
        color: rgba(255, 255, 255, 0);
        transition: all 0.5s ease-in;
        .info {
          position: relative;
          top: 50%;
          transform: translateY(-50%);
        }
      }
    }
    &:hover .mask {
      background-color: rgba(0, 0, 0, 0.5);
      color: rgba(255, 255, 255, 1);
    }
    &:nth-child(1) {
      width: @bigWidth;
      height: @bigHeight;
      left: 0;
      top: 0;
      img {
        object-fit: cover;
        width: @bigWidth;
        height: @bigHeight;
      }
    }
    &:nth-child(2) {
      left: @bigWidth+ @gap10;
      top: 0;
    }
    &:nth-child(3) {
      left: @bigWidth+ @gap10;
      top: @smallHeight+ @gap10;
    }
    &:nth-child(4) {
      left: @bigWidth+ @gap10;
      top: (@smallHeight+ @gap10) * 2;
    }
    &:nth-child(5) {
      left: @smallWidth+ @gap10;
      top: (@smallHeight+ @gap10) * 2;
    }
    &:nth-child(6) {
      left: 0;
      top: (@smallHeight+ @gap10) * 2;
    }
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>

